export class LicensesFinalPaymentModal {
    licenseAmount: number;
    licenseNotes: string;
    validityAmount: number;
    validityNotes: string;
    servicesAmount: number;
    servicesNotes: string;
    validityFinalAmount: number;
    validityFinalNote: string;
    licenseFinalAmount: number;
    licenseFinalNotes: string;
    subTotal: number;
    tax: number;
    totalAmount: number;
    finalNotes: string;
    singleLicenseCost:number;
    validityDays:number;

}
